import Vue from "vue";

const fail = error => {
  Vue.$notification.error(error.message, { offset: 120 });
  throw error;
};

export default {
  getTrainings({ commit, state }, filters = {}) {
    commit("loading", true);
    return Vue.$http
      .get("/hrm/trainings/my", {
        params: { page: state.currentPage, perPage: state.perPage, ...filters },
      })
      .then(response => {
        commit("trainings", response.data.results || []);
        commit("total", response.data.total || 0);
        return response.data;
      })
      .catch(fail)
      .finally(() => commit("loading", false));
  },
  getTraining({ commit }, id) {
    commit("loading", true);
    return Vue.$http
      .get(`/hrm/trainings/my/${id}`)
      .then(response => {
        commit("currentTraining", response.data);
        return response.data;
      })
      .catch(fail)
      .finally(() => commit("loading", false));
  },
  updateProgress({ dispatch }, { id, status, score }) {
    return Vue.$http
      .patch(`/hrm/trainings/${id}/progress`, { status, score })
      .then(response => {
        Vue.$notification.success(response.message);
        return dispatch("getTraining", id);
      })
      .catch(fail);
  },
  changePage({ commit, dispatch }, { page, filters }) {
    commit("currentPage", page);
    return dispatch("getTrainings", filters);
  },
  changeSize({ commit, dispatch }, { perPage, filters }) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    return dispatch("getTrainings", filters);
  },
};
